import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BackButton } from "../../../components/buttons/backButton";
import { Button } from "../../../components/buttons/button";
import { TicketBody } from "../../../components/ticket";
import { guestEventsLSKey } from "../../../utils/constants";
import { handleDownloadPdf } from "../../../utils/helpers";
import { LSGuestDetails } from "../../../utils/types";

export const GuestViewTicket = () => {
  const ticketRef = useRef<HTMLDivElement>(null);
  const { index } = useParams<{ index: string }>();

  const navigate = useNavigate();

  const guestEventDetails: LSGuestDetails = JSON.parse(
    localStorage.getItem(guestEventsLSKey) ?? "[]",
  );

  if (guestEventDetails.length === 0 || !index) {
    navigate(-1);
  }

  const singleEventDetails = guestEventDetails[Number(index)];

  return (
    <div className="flex w-full justify-center">
      <div className="flex w-full max-w-[460px] flex-col gap-3">
        <BackButton />

        <TicketBody
          ref={ticketRef}
          downloadView={false}
          eventName={singleEventDetails.guest?.eventId?.name || ""}
          startDate={singleEventDetails.guest.eventId?.startDate || ""}
          endDate={singleEventDetails.guest.eventId?.endDate || ""}
          startTime={singleEventDetails.guest.eventId?.startTime || ""}
          location={singleEventDetails.guest?.eventId?.location || ""}
          qrCode={singleEventDetails.guest.qrCode || ""}
          firstName={singleEventDetails.guest.firstName || ""}
          lastName={singleEventDetails.guest.lastName || ""}
          email={singleEventDetails.guest.email || ""}
          ticketsPurchase={singleEventDetails.purchase || []}
        />

        <Button
          type="button"
          className="!rounded-2xl"
          onClick={async () => {
            await handleDownloadPdf(
              ticketRef,
              `${singleEventDetails.guest?.eventId?.name}_ticket`,
            );
          }}
          text="Download"
          icon="download"
          variation="white"
        />
      </div>
    </div>
  );
};
